export default "/images/286b0b517245cb8a6b97749d473fde45.avif";